// Package imports:
import React, { useState } from "react";
// Component imports:
import Modal from "../../ui-elements/Modal/Modal";
import Button from "../../ui-elements/Button/Button";
import Link from "../../ui-elements/Link/Link";
import Input from "../../ui-elements/Input/Input";
import Checkbox from "../../ui-elements/Input/Checkbox";

interface IProps {
    show: boolean,
    close(): void,
    onPurchaseUrl(modalReference: string, modalBool: boolean): string,
    onPurchaseCallback(modalReference: string, modalBool: boolean): void,
    dataSourceText: string,
    customText?: string | JSX.Element,
    customHeader?: string,
    type: 'bonds' | 'addresses'
};

const SearchConfirmModalWithReferenceAndBool: React.FC<IProps> = ({
    show,
    close,
    onPurchaseUrl,
    onPurchaseCallback,
    dataSourceText,
    customText,
    customHeader,
    type
}) => {
    const [ reference, setReference ] = useState('');
    const [ bonds, setBonds ] = useState(false);

    return (
        <Modal
            className="KCL_search-confirm-modal"
            show={show}
            onHide={close}
            body={
                <>
                    {(customHeader)
                        ? <h3>{customHeader}</h3>
                        : <h3>Kaupa gögn úr {dataSourceText}.</h3>
                    }
                    
                    <div className="infoSection">
                        {(customText)
                            ? customText
                            : (
                                <p>
                                    Þú ert að fara að kaupa gögn úr {dataSourceText}. Gögn eru samkvæmt
                                    <Link className='VerdskraLink' linkSize='18' url="/Verdskra#verdskra/">verðskrá Keldunnar</Link>
                                    .
                                </p>
                            )
                        }
                        <p>Þú getur sett tilvísun á reikninginn hér fyrir neðan:</p>
                        <div className='reference-wrapper'>
                            <Input
                                name="tilvisun"
                                id="tilvisun"
                                value={reference}
                                label="Tilvísun á reikning"
                                onChange={(e) => setReference(e.target.value)}
                            />
                        </div>
                        <div className='bool-wrapper'>
                            <Checkbox
                                label={(type === 'bonds') ? "Kaupa með veðböndum" : "Kaupa með heimilisföngum"}
                                name="searchconfirmmodalbool"
                                id="searchconfirmmodalbool"
                                value={bonds ? 'true' : 'false'}
                                onChange={(e) => {
                                    setBonds(e.target.checked)
                                }}
                            />
                        </div>
                    </div>
                    <div className="actions">
                        <Button
                            onClick={close}
                            buttonType='secondary'
                        >
                            Hætta við
                        </Button>
                        <Button
                            anchorProps={{
                                href: onPurchaseUrl(reference, bonds),
                                target: '_blank',
                                onClick: () => onPurchaseCallback(reference, bonds)
                            }}
                        >
                            Halda áfram
                        </Button>
                    </div>
                </>
            }
        />
    );
}

export default SearchConfirmModalWithReferenceAndBool;